import React from 'react';

function BankIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        id="Round"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.17 6.02116L11.07 1.86116C11.65 1.55116 12.35 1.55116 12.93 1.86116L20.83 6.02116C21.24 6.23116 21.5 6.66116 21.5 7.12116C21.5 7.81116 20.94 8.37116 20.26 8.37116H3.75C3.06 8.37116 2.5 7.81116 2.5 7.12116C2.5 6.66116 2.76 6.23116 3.17 6.02116ZM4.5 11.8712V15.8712C4.5 16.7012 5.17 17.3712 6 17.3712C6.83 17.3712 7.5 16.7012 7.5 15.8712V11.8712C7.5 11.0412 6.83 10.3712 6 10.3712C5.17 10.3712 4.5 11.0412 4.5 11.8712ZM10.5 11.8712V15.8712C10.5 16.7012 11.17 17.3712 12 17.3712C12.83 17.3712 13.5 16.7012 13.5 15.8712V11.8712C13.5 11.0412 12.83 10.3712 12 10.3712C11.17 10.3712 10.5 11.0412 10.5 11.8712ZM21.5 20.8712C21.5 21.7012 20.83 22.3712 20 22.3712H4C3.17 22.3712 2.5 21.7012 2.5 20.8712C2.5 20.0412 3.17 19.3712 4 19.3712H20C20.83 19.3712 21.5 20.0412 21.5 20.8712ZM16.5 11.8712V15.8712C16.5 16.7012 17.17 17.3712 18 17.3712C18.83 17.3712 19.5 16.7012 19.5 15.8712V11.8712C19.5 11.0412 18.83 10.3712 18 10.3712C17.17 10.3712 16.5 11.0412 16.5 11.8712Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default BankIcon;
